<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-5/6">
      <vx-card>
        <payment-option-container
          :transactionProduct="transactionProduct"
          @pay="pay"
        >
          <!-- header -->
          <template v-slot:header>
            <div class="flex mb-8">
              <router-link v-if="$route.query.mt" :to="`/bayar-zis?ft=${ $route.query.ft ? $route.query.ft : 1 }&t=${$route.query.t ? $route.query.t : 'zakat'}`">
                <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
              </router-link>
              <router-link v-else :to="`/bayar-zis?type=${$route.query.t ? $route.query.t : 'zakat'}`">
                <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
              </router-link>
              <strong class="text-primary"><small>Pilih Metode dPembayaran</small></strong>
            </div>
          </template>
          <!-- / -->

          <!-- Content -->
          <template v-slot:content="{ paymentGateways }">
            <div class="mb-8 vx-row mx-0 w-full justify-center items-center">
              <div class="vx-col w-full md:w-1/2 mb-3 md:mb-0">
                <vs-button type="filled" class="w-full" size="large" @click.prevent="showPaymentGateway('va')">
                  <small>Virtual Account</small>
                </vs-button>
              </div>
              <div class="vx-col w-full md:w-1/2">
                <vs-button type="border" class="w-full" size="large" @click.prevent="showPaymentGateway('other')">
                  <small>Lainnya</small>
                </vs-button>
              </div>
            </div>
            <div 
                class="vx-col w-full rounded-lg mb-6"
                v-for="(item, i) in paymentGateways"
                :key="i"
                style="border: 1px solid #ccc;cursor: pointer;"
            >
              <div class="vx-row py-4 px-4 items-center" @click.prevent="selectedPayment = item.id">
                <div class="vx-col w-1/4 md:w-1/6">
                  <img v-if="item.file === null" :src="`/assets/images/payment_method/${item.code}.png`" alt="" class="w-12 md:w-16 block text-left" />
                  <img v-else :src="item.file" alt="" class="w-12 md:w-16 block text-left" />
                </div>
                <div class="vx-col w-1/2 md:w-2/3">
                  <h5 class="text-left text-sm md:text-md lg:text-lg">
                    <strong>{{item.name}}</strong>
                  </h5>
                  <small v-if="item.code === 'saldo' && notEnoughBalance" class="mt-2">
                    Saldo anda tidak mencukupi
                  </small>
                </div>
                <div class="vx-col w-1/4 md:w-1/6 text-right">
                  <div v-if="item.code === 'saldo'">
                    <vs-button
                      v-if="notEnoughBalance"
                      type="border"
                      class="rounded-none p-2"
                      color="primary"
                      size="small"
                      @click.prevent="$router.push('/balance/checkout')"
                    >
                    Isi Saldo
                    </vs-button>
                    <div class="mx-auto" v-else>
                        <input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
                    </div>
                  </div>
                  <div class="mx-auto" v-else>
                      <input type="radio" :value="item.id" v-model="selectedPayment" class="rad" />
                  </div>
                </div>
              </div>
            </div>
          </template>          
          <!-- / -->

          <!-- description -->
          <template v-slot:description="{ transactionProduct }">
            <table class="w-full px-4 mb-8">
              <tr v-if="transactionProduct.mt !== null && sahabat_name !== null">
                <td class="text-left">
                  <strong class="text-grey">Sahabat ZX</strong>
                </td>
                <td class="text-right">
                  <strong>{{sahabat_name}}</strong>
                </td>
              </tr>
              <tr class="mb-4">
                <td class="text-left">
                  <strong class="text-grey">Jenis Dana</strong>
                </td>
                <td class="text-right">
                  <strong>{{ transactionProduct.name }}</strong>
                </td>
              </tr>
              <tr class="mb-4">
                <td class="text-left">
                  <strong class="text-grey">Nominal</strong>
                </td>
                <td class="text-right">
                  <strong>{{ formatRupiah(transactionProduct.jumlah_bayar) }}</strong>
                </td>
              </tr>
              <tr class="mb-4" v-if="transactionProduct.description && transactionProduct.description !== null">
                <td class="text-left">
                  <strong class="text-grey">Deskripsi</strong>
                </td>
                <td class="text-right">
                  <strong>{{ (transactionProduct.description) }}</strong>
                </td>
              </tr>
              <tr class="mb-4">
                <td class="text-left">
                  <strong class="text-grey">Total Pembayaran</strong>
                </td>
                <td class="text-right">
                  <strong>{{ formatRupiah(transactionProduct.jumlah_bayar) }}</strong>
                </td>
              </tr>
            </table>
          </template>
          <!-- / -->
        </payment-option-container>
      </vx-card>

		</div>
	</section>
</template>
<script>
import { mapState } from 'vuex'
export default {
	components: {
		PaymentOptionContainer: () => import('@/views/components/transaction/CheckoutPaymentOption.vue')
	},
  data: () => ({
    paymentGateways: [],
    transaction: {},
    transactionProduct: {},
    balance: 500000,
    sahabat_name: null
  }),
  computed: {
    selectedPayment: {
      get() {
        return this.$store.state['payment-gateway'].selectedPayment
      },
      set(val) {
        this.$store.dispatch('payment-gateway/setSelectedPayment', val)
      }
    },
    type () {
      return this.$route.query.t ? this.$route.query.t : 'zakat'
    },
    ...mapState('payment-gateway', ['va_payment_gateway', 'other_payment_gateway', 'payment_gateway']),
    ...mapState('mitra', ['choiceMitra']),
    notEnoughBalance() {
      const amount = this.$route.query.amount ? this.replaceAll(this.$route.query.amount.toString(), '.', '') : 10000
      if( this.balance < parseInt(amount) ) {
        return true
      }

      return false
    }
  },
  methods: {
  	selectPayment(payment_id) {
  		this.selectedPayment = payment_id;
  	},
    pay (payment) {
      	
      if (!payment) {
        this.$vs.notify({
          title: 'Metode Pembayaran Tidak ditemukan',
          text: 'coba beberapa saat lagi',
          color: 'warning',
          position: 'top-right'
        });

        return false;
      }

      // Set selected payment method
      this.$store.dispatch(`${this.type  }/setTransactionPayment`, payment)

      let nextLink = `/bayar-zis/payment-confirm?ft=${this.$route.query.ft}`;
      nextLink += this.$route.query.amount ? `&amount=${this.$route.query.amount}` : '';
      nextLink += this.$route.query.t ? `&t=${this.$route.query.t}` : '';
      nextLink += this.$route.query.mt ? `&mt=${this.$route.query.mt}` : '';
      nextLink += this.$route.query.ref ? `&ref=${this.$route.query.ref}` : '';

      this.$router.push(nextLink);
      
    },
    showPaymentGateway (typePayment) {
      if (typePayment === 'va') {
        const pg = this.va_payment_gateway.slice()
        this.$store.dispatch(`payment-gateway/changePaymentGateway`, pg)
      } else {
        const pg = this.other_payment_gateway.slice()	
        this.$store.dispatch(`payment-gateway/changePaymentGateway`, pg)
      }
    },
    getPaymentGateway () {
      this.$vs.loading()

      this.$store.dispatch('payment-gateway/getPaymentGateway', {is_enabled: 1})
        .then(() => {
          this.$vs.loading.close()
          this.paymentGateways = this.va_payment_gateway
            .slice()
          
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    }
  },
  created () {
  	this.checkVerifyAccount()
  	if(this.$store.getters[`${this.type  }/transactionProduct`] == null) {
  		this.$router.push(`/zxcare`)
  	}
    Object.assign(this.transactionProduct, this.$store.getters[`${this.type}/transactionProduct`])
    if(this.transactionProduct.mt !== null) {
    	const sahabat = this.choiceMitra.slice(),
    		find = sahabat.find(it => {
    			if(it.user) {
    				return it.user.id == this.transactionProduct.mt
    			}
    		})
    	if(find) {
    		this.sahabat_name = find.user ? find.user.name : find.name
    	}
    }
  }
}
</script>
<style>
    .rad {
        position: relative;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        font: inherit;
        width: 1rem;
        height: 1rem;
        border: 2px solid #FFCB05;
        border-radius: 50%;
    }
    .rad::before {
        content: '';
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em #045532;
        background: #045532;
    }
    .rad::after {
        content: '';
        opacity: 0;
        display: block;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        background: #045532;
    }
    .rad:checked {
        border: 2px solid #045532;
        transition: .1s ease-in;
        transform: scale(1.3);
    }
    .rad:checked::after {
        opacity: 1;
    }
</style>